import React from "react";
import { statusColor } from "../lib/provinces";
import { formatNumber } from "../lib/format";

export const KamtibmasCard = ({ data }) => {
  if (!data) {
    return (
      <div className="nms-card right-card kamtib-card" data-testid="kamtibmas-card">
        <div className="rc-head">
          <h3 className="rc-title">KAMTIBMAS — {new Date().getFullYear()}</h3>
        </div>
        <div className="sentiment-empty">Loading…</div>
      </div>
    );
  }

  const statusToken =
    data.status?.toLowerCase() === "tinggi"
      ? "kritis"
      : data.status?.toLowerCase() === "sedang"
      ? "waspada"
      : data.status?.toLowerCase() === "rendah"
      ? "aman"
      : "siaga";

  const col = statusColor(statusToken);

  return (
    <div className="nms-card right-card kamtib-card" data-testid="kamtibmas-card">
      <div className="rc-head kamtib-head">
        <h3 className="rc-title kamtib-title">
          KAMTIBMAS — <span className="kamtib-year">{data.year}</span>
        </h3>
        <span className="kamtib-status-pill" style={{ color: col, borderColor: col }}>
          ● {(data.status || "—").toUpperCase()}
        </span>
      </div>

      <div className="kamtib-row">
        <div className="kamtib-gauge">
          <svg viewBox="0 0 60 60" width="56" height="56">
            <circle
              cx="30"
              cy="30"
              r="24"
              stroke="rgba(245, 158, 11, 0.18)"
              strokeWidth="6"
              fill="none"
            />
            <circle
              cx="30"
              cy="30"
              r="24"
              stroke="#f59e0b"
              strokeWidth="6"
              fill="none"
              strokeLinecap="round"
              strokeDasharray={`${(Math.min(100, data.score) / 100) * 150.8} 150.8`}
              transform="rotate(-90 30 30)"
            />
            <text
              x="30"
              y="30"
              dy="6"
              textAnchor="middle"
              fontSize="14"
              fontWeight="700"
              fill="#fff"
              fontFamily="IBM Plex Mono, monospace"
            >
              {data.score}
            </text>
            <text
              x="30"
              y="42"
              dy="6"
              textAnchor="middle"
              fontSize="6"
              fill="#94a3b8"
              fontFamily="IBM Plex Mono, monospace"
            >
              AVG IDX
            </text>
          </svg>
        </div>
        <div className="kamtib-status-block">
          <div className="kamtib-status-label">STATUS HARI INI</div>
          <div className="kamtib-status-value" style={{ color: col }}>
            {formatNumber(data.totalLatest)} KEJADIAN
          </div>
        </div>
      </div>

      <div className="kamtib-metrics-grid">
        {(data.metrics || []).map((m) => (
          <div key={m.id} className="km-metric" data-testid={`kamtib-${m.id}`}>
            <div className="km-metric-head">
              <span className="km-metric-label">{m.label}</span>
              <span className="km-metric-total">{m.total}</span>
            </div>
            <div className="km-metric-bar">
              <div className="km-metric-fill" style={{ width: `${m.share}%` }} />
            </div>
            <span className="km-metric-val">{m.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KamtibmasCard;
